'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildUsageTrackingMiddleware;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _connectLoggerMiddleware = require('event-tracking-tools/redux/connectLoggerMiddleware');

var _connectLoggerMiddleware2 = _interopRequireDefault(_connectLoggerMiddleware);

var _ProductEventLogger = require('event-tracking-tools/loggers/ProductEventLogger');

var _ProductEventLogger2 = _interopRequireDefault(_ProductEventLogger);

var _MessagesEventSchema = require('conversations-core/hublytics/MessagesEventSchema');

var _MessagesEventSchema2 = _interopRequireDefault(_MessagesEventSchema);

var _hublyticsHandlers = require('conversations-core/hublytics/hublyticsHandlers');

var _hublyticsHandlers2 = _interopRequireDefault(_hublyticsHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildUsageTrackingMiddleware(messagesUtk) {
  var hublyticsOptions = {
    app: 'livemessageswidget',
    useStrict: false,
    who_identifier_v2: 'TEMP_ID:::' + messagesUtk + ':::53',
    accountId: 53,
    env: _enviro2.default.getShort(),
    teamIdentifier: _hubspot2.default.get()
  };

  return (0, _connectLoggerMiddleware2.default)(_MessagesEventSchema2.default, _ProductEventLogger2.default, hublyticsOptions, _hublyticsHandlers2.default);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/higherOrderMiddleware/buildUsageTrackingMiddleware.js
// module id = 555
// module chunks = 0